import { handleActions } from 'redux-actions'

const initialState = {}

function createRequestReducer ([ request, failure, receive ]) {
  return handleActions({
    [request] (state, { payload }) {
      return {
        ...state,
        [payload.requestKey]: {
          isRequesting: true,
          didRequestFail: false,
          didRequest: false,
          error: null
        }
      }
    },
    [failure] (state, { payload, error }) {
      return {
        ...state,
        [payload.requestKey]: {
          isRequesting: false,
          didRequestFail: true,
          didRequest: true,
          error: error && error.message
        }
      }
    },
    [receive] (state, { payload }) {
      return {
        ...state,
        [payload.requestKey]: {
          isRequesting: false,
          didRequestFail: false,
          didRequest: true,
          error: null
        }
      }
    }
  }, initialState)
}

export default createRequestReducer



// WEBPACK FOOTER //
// ./reducers/utils/create-request-reducer.js